<div class="card bg-light">
  <div class="card-header">
    <h3>Release History</h3>
    <div>
      A list of historical release notes.  To view the notes, click the download button and the file will download for your review.
    </div>
    <div *ngIf="this.releaseHistory" class="card-body">
      <mat-table class="table table-bidit table-hover" [dataSource]="this.dataSource">
        <ng-container matColumnDef="releaseSettings_Description">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Release</mat-header-cell>
          <mat-cell *matCellDef="let release">
            <div [innerHTML]="release.releaseSettings_Description"></div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="releaseSettings_Summary">
          <mat-header-cell *matHeaderCellDef class="bidit-header col-sm-8" i18n>Summary</mat-header-cell>
          <mat-cell class="col-sm-8" *matCellDef="let release">
            <div [innerHTML]="release.releaseSettings_Summary"></div>
          </mat-cell>
        </ng-container>

        <ng-container class="float-end" matColumnDef="action">
          <mat-header-cell *matHeaderCellDef class="bidit-header col-sm-1" i18n></mat-header-cell>
          <mat-cell class="col-sm-1" *matCellDef="let release">
            <button *ngIf="release.releaseSettings_FileName != null" (click)="downloadAttachment(release)" class="btn btn-bidit-navigate mr-1" i18n>Download</button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator [length]="this.releaseHistory.length" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
    </div>
  </div>
</div>
